'use strict';

import $ from 'jquery';

let productHero = {
  $hero: null,
  $bgVideoWrap: null,
  bgVideo: null,

  onResize: function(){
    if(this.bgVideo){
      if(this.$bgVideoWrap.is(':visible')){
        this.bgVideo.play();
      } else {
        this.bgVideo.pause();
      }
    }
  },

  init: function(){
    const self = this;
    this.$hero = $('.section-product-hero');
    this.$bgVideoWrap = $('.section-product-hero__bg-video');
    this.bgVideo = this.$bgVideoWrap.find('video').get(0);

    $(window).on('resize', function(){
      clearTimeout(self.resizeTimer);
      self.resizeTimer = setTimeout(self.onResize, 500);
    });
  }
};

export default productHero;
